import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { v4 as uuid, } from 'uuid';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class FlDmvDetailedRenewal extends React.Component {
  constructor(props) {
    super(props);
    const { renewal = {}, } = this.props;

    let contributionHeaders = [];
    const contributionRows = [];

    if (renewal?.voluntaryContributions?.length) {
      contributionHeaders = Object.keys(renewal.voluntaryContributions[0]);
      contributionHeaders = contributionHeaders.map(header => ({
        value: header,
        display: _.startCase(header),
      }));

      renewal.voluntaryContributions?.forEach((contribution) => {
        contributionRows.push({
          value: Object.values(contribution),
          raw: contribution,
        });
      });
    }

    this.state = {
      renewal,
      contributionHeaders,
      contributionRows,
    };
  }

  static exclusions = [ 'className', 'mongoId', 'customerIds', 'payments', ];

  render() {
    const { renewal, contributionHeaders, contributionRows, } = this.state;

    const items = VerticalLabelList.toList({
      Id: renewal.id,
      'Customer Id': renewal.customerId,
      'HSMV Receipt Number': renewal.hsmvReceiptNumber,
      'Failed By Florida': renewal.failedByFlorida,
      'Date of Birth': moment(renewal.dateOfBirth).utc().format('YYYY-MM-DD'),
      'Renewal Date': moment(renewal.renewalDate)
        .utc()
        .format(),
      'FL Renewal Payment Timestamp': moment(renewal.flRenewalPayment?.timestamp)
        .utc()
        .format(),
      'Payment Has Been Processed': renewal.flRenewalPayment?.hasBeenProcessed,
      Deleted: renewal.deleted,
      'FL Total Amount': renewal.flTotalAmount,
      'FL Renewal Payment PayIt Payment Id': renewal.flRenewalPayment?.payitPaymentId,
    });

    const renewalItems = renewal.vehicleRenewalItems?.map(renewalItem => VerticalLabelList.toList({
      'Registration Number': renewalItem.registrationNumber,
      'Plate Number': renewalItem.plateNumber,
      'Amount Due': renewalItem.amountDue,
      Term: renewalItem.term,
      'Renewal Type': renewalItem.renewalType,
      'HSMV Signature': renewalItem.hsmvSignature,
    }));

    return (
      <div>
        <FieldSet title="Renewal Summary" style={{ maxHeight: '300px', }}>
          <VerticalLabelList items={items} />
        </FieldSet>
        {renewalItems.map(item => (
          <div style={{ marginTop: '20px', }} key={uuid()}>
            <FieldSet title="Vehicle Renewal Items">
              <VerticalLabelList items={item} />
            </FieldSet>
          </div>
        ))}
        <FieldSet title="Voluntary Contributions">
          <Grid
            headers={contributionHeaders}
            rows={contributionRows}
            onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            onRowSelect={row => this.onRowSelect(row)}
          />
        </FieldSet>
      </div>
    );
  }
}

FlDmvDetailedRenewal.propTypes = {
  renewal: PropTypes.instanceOf(Object).isRequired,
};

export default FlDmvDetailedRenewal;
